export default "__VITE_ASSET__CEiGjonY__"